import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { ScannerAutoTrial } from "./ScannerAutoTrial.component";




export function showScannerAutoTrialModal(modalService: NgbModal, mobileMode: string = 'desktop') {
    const mobile = mobileMode != 'desktop';
    const component = ScannerAutoTrial;// mobile? MobileDisconnectionInfoModalComponent: ScannerTrialPopup;
    const windowClass = "dark-modal largeWindow" + (mobile? ' mobile': '');
    let m: NgbModalRef = modalService.open(component, {
        backdrop: "static",
        size: "sm",
        centered: true,
        windowClass: windowClass
    });
    let modal = (<ScannerAutoTrial>m.componentInstance);
    return modal;
}
